const EventCarousel = {
  mounted() {
    this.track = this.el
    this.slides = Array.from(this.track.children)
    this.position = 0
    this.slideWidth = 292
    this.carousel = this.track.closest('.carousel-wrapper')
    this.totalSlides = this.track.children.length
    this.visibleWidth = this.carousel.offsetWidth;
    this.updateMaxIndex()

    const container = this.track.closest('.carousel-container')

    this.prevButton = container.querySelector('.carousel-prev')
    this.nextButton = container.querySelector('.carousel-next')

    this.prevButton.addEventListener('click', this.prev.bind(this))
    this.nextButton.addEventListener('click', this.next.bind(this))

    window.addEventListener('resize', this.handleResize.bind(this))

    this.observeFilterPanel()

    this.updatePosition()
  },

  updated() {
    this.totalSlides = parseInt(this.track.dataset.slideCount, 10)
    this.updateMaxIndex()
  },

  prev() {
    if (this.position > 0) {
      this.position--;
      this.updatePosition();
    }
  },

  next() {
    if (this.position < this.maxIndex) {
      this.position++;
      this.updatePosition();
    }
  },

  handleResize() {
    this.visibleWidth = this.carousel.offsetWidth
    this.updateMaxIndex()
    this.updatePosition()
  },

  observeFilterPanel() {
    const container = document.querySelector('#education_search_container')

    if (!container) {
      return
    }

    const observer = new MutationObserver(() => {
      setTimeout(() => {
        this.handleResize()
      }, 300)
    })

    observer.observe(container, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    })
  },

  updateMaxIndex() {
    const extraPadding = 20
    const totalWidth = (this.totalSlides * this.slideWidth) + extraPadding

    this.maxIndex = Math.max(0, Math.ceil((totalWidth - this.visibleWidth) / this.slideWidth))
  },

  updatePosition() {
    const extraPadding = 20
    const maxTranslateX = (this.totalSlides * this.slideWidth) - this.visibleWidth + extraPadding
    let translateX = -(this.position * this.slideWidth)

    if (Math.abs(translateX) > maxTranslateX) {
      translateX = -maxTranslateX
    }

    this.track.style.transform = `translateX(${translateX}px)`

    const atStart = this.position <= 0
    const atEnd = this.position >= this.maxIndex

    this.toggleDisabled(this.prevButton, atStart)
    this.toggleDisabled(this.nextButton, atEnd)
  },

  toggleDisabled(btn, isDisabled) {
    if (!btn) {
      return
    }
    btn.classList.toggle('opacity-10', isDisabled)
    btn.classList.toggle('pointer-events-none', isDisabled)
    btn.disabled = isDisabled
  },
};

export default EventCarousel
